<section class="sql-playground">
  <div class="playground-layout">
    <!-- Left: Version Files + Custom Files -->
    <div class="playground-left">
      <div class="playground-card playground-card--files">
        <div class="playground-card__header">
          <h4 class="playground-card__title">Version Files</h4>
          <div
            class="playground-info-wrap"
            (mouseenter)="showVersionFilesTooltip($event)"
            (mouseleave)="hideVersionFilesTooltip()"
          >
            <img
              class="playground-info-icon"
              src="/icons/info-circle.svg"
              width="16"
              height="16"
              alt=""
              title="Info"
            />
            <div
              class="playground-tooltip playground-tooltip--fixed"
              [style.top.px]="versionFilesTooltipTop"
              [style.left.px]="versionFilesTooltipLeft"
              [class.visible]="versionFilesTooltipVisible"
            >
              <p class="playground-tooltip__text">Data files (JSON, CSV, TSV, Parquet) from this dataset version that you can query.</p>
            </div>
          </div>
        </div>

        @if (loadingFiles) {
          <div class="playground-loading">
            <div class="playground-spinner"></div>
            <p>Loading files...</p>
          </div>
        }
        @if (uploadError) {
          <div class="playground-error">
            <p>{{ uploadError }}</p>
          </div>
        }
        @if (filesError && !loadingFiles) {
          <div class="playground-error">
            <p>{{ filesError }}</p>
          </div>
        }
        @if (!loadingFiles && !filesError && displayFiles.length === 0) {
          <div class="playground-empty">
            <p>No files available</p>
          </div>
        }
        @if (!loadingFiles && !filesError && displayFiles.length > 0) {
          <div class="playground-files-grid">
            @for (file of displayFiles; track file.name) {
              <div
                class="playground-file-card"
                [class.selected]="file.isSelected"
                [class.loading]="loadingVersionFileName === file.name"
                (click)="loadingVersionFileName ? null : onFileCardClick(file)"
              >
                <div class="playground-file-card__row">
                  <div class="playground-file-card__name-wrap">
                    <img
                      class="playground-file-card__icon"
                      src="/icons/file-document.svg"
                      width="18"
                      height="18"
                      alt=""
                    />
                    <span class="playground-file-card__name">{{ file.name }}</span>
                  </div>
                  @if (file.isSelected) {
                    <div
                      class="playground-info-wrap"
                      (click)="toggleFileDetails(file.name, 'version'); $event.stopPropagation()"
                    >
                      <img
                        class="playground-info-icon"
                        [class.expanded]="isFileDetailsExpanded(file.name, 'version')"
                        src="/icons/info-circle.svg"
                        width="16"
                        height="16"
                        alt=""
                        title="Toggle file details"
                      />
                    </div>
                  }
                </div>
                @if (loadingVersionFileName === file.name) {
                  <div class="playground-file-card__loading">
                    <div class="playground-spinner"></div>
                    <span>Loading into DuckDB...</span>
                  </div>
                }
                @if (isFileDetailsExpanded(file.name, 'version')) {
                  <div class="playground-details-panel" (click)="$event.stopPropagation()">
                    <div class="playground-details-panel__header">File details</div>
                    <div class="playground-details-panel__body">
                      <div class="playground-details-row">
                        <span class="playground-details-label">Table name</span>
                        <span class="playground-details-value playground-details-code playground-copyable" title="Select to copy">{{ loadedVersionFiles.get(file.name) ?? generateTableNameFromFileName(file.name) }}</span>
                      </div>
                      @if (file.size || displayFilesTotalSize) {
                        <div class="playground-details-row">
                          <span class="playground-details-label">File size</span>
                          <span class="playground-details-value">{{ file.size || displayFilesTotalSize }}</span>
                        </div>
                      }
                      @if (file.license || license()) {
                        <div class="playground-details-row">
                          <span class="playground-details-label">License</span>
                          <span class="playground-details-value">{{ file.license || license() }}</span>
                        </div>
                      }
                      @if (file.lastUpdated || displayFilesLastUpdated) {
                        <div class="playground-details-row">
                          <span class="playground-details-label">Last updated</span>
                          <span class="playground-details-value">{{ file.lastUpdated || displayFilesLastUpdated }}</span>
                        </div>
                      }
                    </div>
                  </div>
                }
              </div>
            }
          </div>
        }

        <!-- Custom Files -->
        <div class="playground-custom-section">
          <div class="playground-custom-header">
            <h4 class="playground-card__title">Custom Files</h4>
            <label class="playground-upload-btn" [class.disabled]="isUploading || isRunning" title="Upload file">
              <input
                type="file"
                (change)="onFileSelected($event)"
                [accept]="fileInputAccept"
                [disabled]="isUploading || isRunning"
                style="display: none;"
              />
              <img src="/icons/upload-line-teal.svg" width="20" height="20" alt="" />
            </label>
          </div>
          @if (customFiles.length > 0) {
            <div class="playground-custom-list">
              @for (file of customFiles; track file.name) {
                <div class="playground-custom-item-wrap">
                  <div class="playground-custom-item" [class.selected]="file.isSelected">
                    <input
                      type="checkbox"
                      class="playground-custom-checkbox"
                      [checked]="file.isSelected"
                      (change)="onCustomFileToggle(file)"
                      [id]="'custom-file-' + file.name"
                    />
                    <div class="playground-custom-content">
                      <span class="playground-custom-name">{{ file.name }}</span>
                    </div>
                    @if (file.isSelected) {
                      <div
                        class="playground-info-wrap"
                        (click)="toggleFileDetails(file.name, 'custom'); $event.stopPropagation()"
                      >
                        <img
                          class="playground-info-icon"
                          [class.expanded]="isFileDetailsExpanded(file.name, 'custom')"
                          src="/icons/info-circle.svg"
                          width="16"
                          height="16"
                          alt=""
                          title="Toggle file details"
                        />
                      </div>
                    }
                    <button
                      type="button"
                      class="playground-custom-remove"
                      (click)="removeCustomFile(file); $event.stopPropagation()"
                      title="Remove file"
                      aria-label="Remove file"
                    >
                      <img src="/icons/close-x.svg" width="16" height="16" alt="" />
                    </button>
                  </div>
                  @if (isFileDetailsExpanded(file.name, 'custom')) {
                    <div class="playground-details-panel playground-details-panel--custom" (click)="$event.stopPropagation()">
                      <div class="playground-details-panel__header">File details</div>
                      <div class="playground-details-panel__body">
                        @if (file.tableName) {
                          <div class="playground-details-row">
                            <span class="playground-details-label">Table name</span>
                            <span class="playground-details-value playground-details-code playground-copyable" title="Select to copy">{{ file.tableName }}</span>
                          </div>
                        }
                        <div class="playground-details-row">
                          <span class="playground-details-label">File size</span>
                          <span class="playground-details-value">{{ file.size }}</span>
                        </div>
                      </div>
                    </div>
                  }
                </div>
              }
            </div>
          }
          @if (customFiles.length === 0) {
            <div class="playground-custom-empty">
              <p>No custom files uploaded yet</p>
            </div>
          }
        </div>
      </div>
    </div>

    <!-- Right: Editor + Results -->
    <div class="playground-right">
      <div class="playground-panel">
        <div class="playground-editor-wrap">
          <div class="playground-editor-container">
            <div class="playground-editor-inner">
              <pre class="playground-editor-highlight" [style.font-size.px]="editorFontSize"><code [innerHTML]="highlightedSql" [style.font-size.px]="editorFontSize"></code></pre>
              <textarea
                class="playground-editor"
                [(ngModel)]="sql"
                [placeholder]="hasSelectedFiles() ? 'Enter your SQL query here...' : 'Select a file to start querying...'"
                [style.height.px]="editorHeight"
                [style.font-size.px]="editorFontSize"
                (input)="onSqlInput($event)"
                (scroll)="onSqlScroll($event)"
              ></textarea>
            </div>
            <div class="playground-editor-actions">
              <button type="button" class="playground-editor-btn" (click)="decreaseFontSize()" title="Decrease font size">
                <span class="playground-font-a">A</span>
                <span class="playground-font-minus">−</span>
              </button>
              <button type="button" class="playground-editor-btn" (click)="increaseFontSize()" title="Increase font size">
                <span class="playground-font-a">A</span>
                <span class="playground-font-plus">+</span>
              </button>
              <button
                type="button"
                class="playground-editor-btn"
                (click)="resetPlayground()"
                [disabled]="isRunning || !canResetPlayground()"
                title="Reset"
              >
                <img src="/icons/editor-reset-white.svg" width="18" height="18" alt="" />
              </button>
              <label class="playground-editor-btn" [class.disabled]="isUploading || isRunning" title="Upload file">
                <input type="file" (change)="onFileSelected($event)" [accept]="fileInputAccept" [disabled]="isUploading || isRunning" style="display: none;"/>
                <img src="/icons/upload-line-white.svg" width="18" height="18" alt="" />
              </label>
              <button
                type="button"
                class="playground-editor-btn playground-editor-btn--run"
                (click)="runQuery()"
                [disabled]="isRunning || !hasSelectedFiles()"
                title="Run Query"
              >
                @if (!isRunning) {
                  <img src="/icons/play-fill-white.svg" width="18" height="18" alt="" />
                }
                @if (isRunning) {
                  <div class="playground-editor-spinner"></div>
                }
              </button>
            </div>
          </div>
        </div>

        <section class="playground-results">
          <header class="playground-results-header">
            <h3 class="playground-results-title">Query Results</h3>
            @if (runStatus !== 'idle') {
              <div class="playground-results-meta">
                @if (executionTimeMs) {
                  <span>Execution time: {{ executionTimeMs }} ms</span>
                }
                @if (resultRows.length) {
                  <span>Rows: {{ resultRows.length }}</span>
                }
              </div>
            }
          </header>

          @if (runStatus === 'error') {
            <div class="playground-results-error" role="alert">
              <strong>Query failed.</strong>
              <span>{{ errorMessage }}</span>
            </div>
          } @else {
            @if (resultRows.length) {
              <div class="playground-results-body">
                <div class="playground-table-wrap">
                  <table class="playground-table">
                    <thead>
                      <tr>
                        @for (column of resultColumns; track column) {
                          <th>{{ column }}</th>
                        }
                      </tr>
                    </thead>
                    <tbody>
                      @for (row of resultRows; track $index) {
                        <tr>
                          @for (column of resultColumns; track column) {
                            <td>{{ row[column] ?? '—' }}</td>
                          }
                        </tr>
                      }
                    </tbody>
                  </table>
                </div>
              </div>
            } @else {
              <div class="playground-results-empty">
                @switch (runStatus) {
                  @case ('success') {
                    <p>No rows returned. Try adjusting filters or selecting different columns.</p>
                  }
                  @case ('idle') {
                    <p>Upload a file and run the query to preview sample output here.</p>
                  }
                  @case ('running') {
                    <p>Fetching results…</p>
                  }
                  @default {
                    <p>Run a query to see results.</p>
                  }
                }
              </div>
            }
          }
        </section>

        <footer class="playground-footer">
          @if (runStatus !== 'idle') {
            <span
              class="playground-run-status"
              [class.running]="runStatus === 'running'"
              [class.success]="runStatus === 'success'"
            >
              @if (runStatus === 'running') {
                <span>Executing query…</span>
              }
              @if (runStatus === 'success' && lastRunAt) {
                <span>Last run {{ getLastRunDisplay() }} IST</span>
              }
            </span>
          }
        </footer>
      </div>
    </div>
  </div>
</section>
